// extracted by mini-css-extract-plugin
export default {"cardStyle":"style_cardStyle__9MN9k"};